import type { ApolloCache } from '@apollo/client'
import type { ShiftsRestDayFragment } from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'

import {
  removeRefsFromEntityField,
  type ViewRange,
} from 'modules/shift_management/utils/apolloCache/appendRefsToEntityField'

const removeDestroyedRestDaysCache = ({
  cache,
  view,
  restDays,
}: {
  cache: ApolloCache<unknown>
  view: ViewRange
  restDays: ShiftsRestDayFragment[]
}) => {
  cache.batch({
    update: (batchedCache) => {
      const restDaysByEmployee = groupBy(restDays, (restDay) => restDay.employee?.id)

      Object.entries(restDaysByEmployee).forEach(([employeeId, employeeRestDays]) => {
        if (!employeeId) return

        removeRefsFromEntityField({
          cache: batchedCache,
          entity: { __typename: 'ShiftManagementEmployeesPermission', id: employeeId },
          fieldName: 'restDays',
          ids: new Set(employeeRestDays.map((restDay) => restDay.id)),
          view,
        })
      })

      restDays.forEach((restDay) => {
        batchedCache.evict({ id: batchedCache.identify(restDay) })
      })
    },
  })
}

export { removeDestroyedRestDaysCache }
